import CalculateIcon from '@mui/icons-material/Calculate';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import SidebarLayout, { MenuGroup } from "./SidebarLayout";

// Section "Matrice Régie" — complètement séparée de Chiffrage Projets et de Navette de paie.
const menuData: MenuGroup[] = [
    {
        groupName: "Matrice régie",
        items: [
            { icon: <RequestQuoteIcon />, text: "Nouvelle simulation", page: "/regie/simulation" },
            { icon: <CalculateIcon />, text: "Barèmes régie", page: "/regie/baremes" },
        ],
    },
];

export default function LayoutRegie() {
    return <SidebarLayout menuData={menuData} />;
}
